import { render, staticRenderFns } from "./AIAnalysisButton.vue?vue&type=template&id=4b1fafdc&scoped=true&"
import script from "./AIAnalysisButton.vue?vue&type=script&lang=js&"
export * from "./AIAnalysisButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAnalysisButton.vue?vue&type=style&index=0&id=4b1fafdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1fafdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VDialog,VIcon,VProgressCircular,VTooltip})
